module.exports = __webpack_public_path__ + "static/img/10a.9363368e.png";